import React from "react";
import { Link } from "react-router-dom";

import styles from "./SideMenu.module.scss";

import { ReactComponent as CreditCardBold } from "../assets/creditCardBold.svg";
import { ReactComponent as HomeBoldIcon } from "../assets/homeBold.svg";
import { ReactComponent as BoxBoldIcon } from "../assets/boxBold.svg";
import { ReactComponent as UserBoldIcon } from "../assets/userBold.svg";
import { ReactComponent as ReportBoldIcon } from "../assets/reportBold.svg";
import { ReactComponent as SettingsBoldIcon } from "../assets/settingsBold.svg";
import { ReactComponent as BalanceIcon } from "../assets/balance.svg";
import { ReactComponent as ChevronIcon } from "../assets/chevron.svg";
import PopupWrapper from "./popup/PopupWrapper";
import { useModal } from "../stores/useModel";
import PlaceholderModal from "./model/PlaceholderModal";

type Props = {};

function SideMenu({}: Props) {
  const { setShowModal, setModalContent } = useModal(state => state);

  return (
    <div className={styles.container}>
      <div className={styles.companyWrapper}>
        {/* <PopupWrapper tooltipText="hello" type="bottom"> */}
        <div
          className={styles.companyContainer}
          onClick={() => {
            setShowModal(true);
            setModalContent(
              <PlaceholderModal>Placeholder for CompanySettings</PlaceholderModal>
            );
          }}
        >
          <div className={styles.avatar}></div>
          <div className={styles.name}>MyCompany</div>
          {/* <ChevronIcon /> */}
        </div>
        {/* </PopupWrapper> */}
      </div>

      <SideMenuRow name="Home" route="/" icon={<HomeBoldIcon />} />
      <SideMenuRow name="Payments" icon={<CreditCardBold />} />
      <SideMenuRow name="Customers" icon={<UserBoldIcon />} />
      <SideMenuRow name="Products" icon={<BoxBoldIcon />} />
      {/* <SideMenuRow name="Balances" icon={<BalanceIcon />} />
      <SideMenuRow name="Reports" icon={<ReportBoldIcon />} />
      <SideMenuRow name="Settings" icon={<SettingsBoldIcon />} /> */}
    </div>
  );
}

interface ISideMenuRow {
  name: string;
  route?: string;
  icon: any;
}
function SideMenuRow({ name, route = name, icon }: ISideMenuRow) {
  return (
    <Link className={styles.row} to={route.toLocaleLowerCase()}>
      <div className={styles.iconWrapper}>{icon}</div>
      <div className={styles.text}>{name}</div>
    </Link>
  );
}

export default React.memo(SideMenu);
